import { Provider } from 'react-redux'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { store } from '@/store'
import { queryClient } from '@/lib/queryClient'
import { router } from '@/router'
import { AuthSessionSync } from '@/components/auth/AuthSessionSync'
import { Toaster } from '@/components/ui/toast'

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthSessionSync />
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </Provider>
  )
}

export default App
